"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DayOfWeek;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function DayOfWeek() {
  return _react2["default"].createElement("thead", null, _react2["default"].createElement("tr", null, _react2["default"].createElement("th", {
    scope: "col",
    className: "rainbow-calendar_header-days"
  }, _react2["default"].createElement("abbr", {
    title: "Sunday"
  }, "Sun")), _react2["default"].createElement("th", {
    scope: "col",
    className: "rainbow-calendar_header-days"
  }, _react2["default"].createElement("abbr", {
    title: "Monday"
  }, "Mon")), _react2["default"].createElement("th", {
    scope: "col",
    className: "rainbow-calendar_header-days"
  }, _react2["default"].createElement("abbr", {
    title: "Tuesday"
  }, "Tue")), _react2["default"].createElement("th", {
    scope: "col",
    className: "rainbow-calendar_header-days"
  }, _react2["default"].createElement("abbr", {
    title: "Wednesday"
  }, "Wed")), _react2["default"].createElement("th", {
    scope: "col",
    className: "rainbow-calendar_header-days"
  }, _react2["default"].createElement("abbr", {
    title: "Thursday"
  }, "Thu")), _react2["default"].createElement("th", {
    scope: "col",
    className: "rainbow-calendar_header-days"
  }, _react2["default"].createElement("abbr", {
    title: "Friday"
  }, "Fri")), _react2["default"].createElement("th", {
    scope: "col",
    className: "rainbow-calendar_header-days"
  }, _react2["default"].createElement("abbr", {
    title: "Saturday"
  }, "Sat"))));
}